export default "__VITE_ASSET__COptxLTH__"